const model = {
    submitting: false,
    errors: null,
    alertDetails: null,
    success: false,
    productUnits: [],
};

export default model;
